export default "__VITE_ASSET__aa0034f8__"